import React from "react";
import PageIntro from "../components/PageIntro";
import privacyData from "../content/privacyPolicy.json";

const PrivacyPolicy = () => {
  return (
    <>
      <PageIntro
        title={privacyData.title}
        subtitle={privacyData.subtitle}
        compactBottom
        contentWidthClass="max-w-[1400px]"
        bottomPadding="pb-4 md:pb-6"
      ></PageIntro>
      <section className="bg-ofWhite overflow-hidden pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          {privacyData.sections.map((section, i) => (
            <div key={i} className="mt-6">
              {section.heading && (
                <h2 className="text-lg font-semibold mb-2">
                  {section.heading}
                </h2>
              )}
              {section.content.map((para, j) => (
                <p
                  key={j}
                  className="text-justify mb-2"
                  dangerouslySetInnerHTML={{ __html: para }}
                />
              ))}
              {section.list && (
                <ul className="list-disc pl-6 mt-2">
                  {section.list.map((item, k) => (
                    <li key={k} dangerouslySetInnerHTML={{ __html: item }} />
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
